import * as React from "react";
import { cn } from "../../lib/utils.js";

/**
 * Textarea primitive — design-token consumer.
 */
export const Textarea = React.forwardRef(
  ({ className, error = false, ...props }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={error || undefined}
      className={cn(
        "flex min-h-[80px] w-full rounded-md px-3 py-2 text-sm",
        "bg-surface-1 text-text-primary placeholder:text-text-muted",
        "border shadow-well transition-colors resize-y",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0",
        // border-strong — mismo criterio que Input (WCAG 1.4.11, 3:1).
        error
          ? "border-danger focus-visible:ring-danger/40"
          : "border-border-strong focus-visible:border-primary focus-visible:ring-primary/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
